import { createSlice } from "redux-starter-kit";

const createState = (state, action) => {
  if (!action) return state;
  return { ...state, ...action.payload };
};

const FollowupQuestionsNew = createSlice({
  slice: "followup_questions_new",
  initialState: {
    pageIndex: 1,
    answers: [],
  },
  reducers: {
    changePage: createState,
    changeFields: createState,
    registerAnswers: createState,
    submitSuccess: createState,
    submitError: createState,
  },
});

export default FollowupQuestionsNew;
